import Parseable from '@/models/Parseable';

export default class User extends Parseable {

    public id!: string;
    public username!: string;
    public firstName?: string;
    public lastName?: string;
    public email?: string;
    public phone?: string;
    public role?: string;

    /**
     * Turns a plain object to a class object
     * @param object
     */
    public static parseFromObject(object: Partial<User>): User {
        const user = new User();
        Object.assign(user, object);
        return user;
    }

    parseToObject(): any {
        const tmp: any = { ...this };
        return tmp;
    }
}
